<template>
  <div>
    <el-container>

      <el-main>

        <br>
        <el-row>
          <el-col :span="24"
                  :offset="0">
            <h2>样例报告</h2>
          </el-col>
          <el-col :span="4"
                  :offset="0">

            <div class="simpleReportImg reportImg">
              <div class="demoTitle"><span>个股分析报告</span></div>
              <div class="desc">快速清洗、加工、整合海量财经数据，一键生成个股深度分析报告，为用户的分析决策提供智能化建议
                <div class="demoBtn">
                  <el-link :underline="false"
                           @click="showPdf(0)">
                    查看样例
                  </el-link>
                </div>
              </div>
            </div>

          </el-col>
          <el-col :span="4"
                  :offset="1">

            <div class="financeReportImg reportImg">
              <div class="demoTitle"><span>财务分析报告</span></div>
              <div class="desc">财务健康诊断、财务问题发现
                <div class="demoBtn">
                  <el-link :underline="false"
                           @click="showPdf(1)">
                    查看样例
                  </el-link>
                </div>
              </div>
            </div>

          </el-col>

          <el-col :span="4"
                  :offset="1">

            <div class="compareReportImg reportImg">
              <div class="demoTitle"><span>组合分析报告</span></div>
              <div class="desc">用户自选一组股票、一键生成投资组合分析报告，综合对比股票各方面情况，快速形成立体认识
                <div class="demoBtn">
                  <el-link :underline="false"
                           @click="showPdf(2)">
                    查看样例
                  </el-link>
                </div>
              </div>
            </div>

          </el-col>
          <el-col :span="4"
                  :offset="1">

            <div class="conceptReportImg reportImg">
              <div class="demoTitle"><span>概念分析报告</span></div>
              <div class="desc">专注概念板块基本面，技术面和消息面的多维分析，快速全面了解热门概念整体情况，为用户的分析决策提供智能化建议
                <div class="demoBtn">
                  <el-link :underline="false"
                           @click="showPdf(3)">
                    查看样例
                  </el-link>
                </div>
              </div>
            </div>

          </el-col>
          <el-col :span="4"
                  :offset="1">

            <div class="hkStockReportImg reportImg">
              <div class="demoTitle"><span>港股分析报告</span></div>
              <div class="desc">通过Al算法模型对港股行情及财务数据进行特征感知，输出A解读，帮助用户快速了解最新进展及所在市场位置
                <div class="demoBtn">
                  <el-link :underline="false"
                           @click="showPdf(4)">
                    查看样例
                  </el-link>
                </div>
              </div>
            </div>

          </el-col>
          <el-col :span="24"
                  :offset="0">
            <h2>如何使用</h2>
          </el-col>

          <el-col :span="9"
                  :offset="0">
            <div class="videoCover"
                 @click="playVideo(0)">
              <video src="../assets/video/demo-simple.mp4"
                     title="">
              </video>
            </div>
          </el-col>
          <el-col :span="14"
                  :offset="1">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="videoCard">
                  <div class="videoCover"
                       @click="playVideo(1)">
                    <video src="../assets/video/demo-finance.mp4"
                           title="">
                    </video>
                  </div>
                  <div class="videoTitle">
                    财务分析报告
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="videoCard">
                  <div class="videoCover"
                       @click="playVideo(2)">
                    <video src="../assets/video/demo-compare.mp4"
                           title="">
                    </video>
                  </div>
                  <div class="videoTitle">
                    组合分析报告
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-col :span="24"><br></el-col>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="videoCard">
                  <div class="videoCover"
                       @click="playVideo(3)">
                    <video src="../assets/video/demo-concept.mp4"
                           title="">
                    </video>
                  </div>
                  <div class="videoTitle">
                    概念分析报告
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="videoCard">
                  <div class="videoCover"
                       @click="playVideo(4)">
                    <video src="../assets/video/demo-hkstock.mp4"
                           title="">
                    </video>
                  </div>
                  <div class="videoTitle">
                    港股分析报告
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

      </el-main>

    </el-container>

    <el-dialog :visible.sync="videoDialogVisible"
               width="60%"
               :before-close="closeVideo">
      <template #title></template>
      <video v-if="videoIndex===0"
             style="width:100%"
             controls
             autoplay
             src="../assets/video/demo-simple.mp4"
             title=""></video>
      <video v-if="videoIndex===1"
             style="width:100%"
             controls
             autoplay
             src="../assets/video/demo-finance.mp4"
             title=""></video>
      <video v-if="videoIndex===2"
             style="width:100%"
             controls
             autoplay
             src="../assets/video/demo-compare.mp4"
             title=""></video>
      <video v-if="videoIndex===3"
             style="width:100%"
             controls
             autoplay
             src="../assets/video/demo-concept.mp4"
             title=""></video>
      <video v-if="videoIndex===4"
             style="width:100%"
             controls
             autoplay
             src="../assets/video/demo-hkstock.mp4"
             title=""></video>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl"
              title="pdf 预览"
              style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="width:100%;text-align:center">
        <!-- <el-button @click="toDownPdf(curSourceId)"
                   size="small">下载</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'

import myNav from '../components/nav'
import myMenu from '../components/menu'
export default {
  name: 'help',
  data: function () {
    return {
      tableLoading: true,
      pdfDialogVisible: false,
      videoDialogVisible: false,
      videoIndex: -1,
      pdfUrl: '',
      sourceId: '',
      pdfSource: [
        './static/pdf/simple.pdf',
        './static/pdf/finance.pdf',
        './static/pdf/compare.pdf',
        './static/pdf/concept.pdf',
        './static/pdf/hkstock.pdf'
      ]
    }
  },
  filters: {

  },
  methods: {
    closeVideo () {
      this.videoIndex = -1
      this.videoDialogVisible = false
    },
    playVideo (index) {
      this.videoDialogVisible = true
      this.videoIndex = index
    },
    showPdf (index) {
      this.pdfUrl = this.pdfSource[index]
      this.pdfDialogVisible = true
    }
  },
  components: {
    myNav, myMenu, Dropzone
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.videoCard{
  display: flex;
    height: 100%;
    justify-items: center;
    align-items: center;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 2px 2px 10px #888;
  .videoCover{
    width:50%;
    display: inline-block
  }
.videoTitle{
  padding-left: 10px;
    font-weight: bold;

}
}

.videoCover{
  position: relative;
  border-radius: 3px;
    overflow: hidden;
    video{
      width:100%;
    }
}
.videoCover::before{
    content: ' ';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #3339;
    text-align: center;

    margin: auto;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;

}
.videoCover::after{
    content: ' ';
    width: 30%;
    height: 30%;
    left: 35%;
    top: 35%;
    position: absolute;

    text-align: center;
background-image: url('../assets/imgs/play.png');
background-size: contain;
background-repeat: no-repeat;
background-position: center;

}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
.el-card{
  border-radius: 20px;
}
.simpleReportImg {
  background: url("../assets/imgs/simpleReportDemoBg.jpg");
}
.financeReportImg {
  background: url("../assets/imgs/financeReportDemoBg.jpg");
}
.tinyReportImg {
  background: url("../assets/imgs/tinyReportDemoBg.png");
}
.compareReportImg {
  background: url("../assets/imgs/compareReportDemoBg.jpg");
}
.conceptReportImg {
  background: url("../assets/imgs/conceptDemoBg.jpg");
}
.hkStockReportImg {
  background: url("../assets/imgs/hkStockDemoBg.jpg");
}

</style>



// WEBPACK FOOTER //
// src/app/help.vue